import initialState from '@/core/store/initialState';
import { isObj, isArr, isNull } from '@/core/utils';

/**
* @description Is valid
* @param narrators
* @returns {boolean}
*/
const isValid = (narrators) => isObj(narrators)
  && isNull(narrators.filters)
  && isArr(narrators.items)
  && isNull(narrators.size)
  && isObj(narrators.activeItem);

/**
* @description Init state
* @param initialState
* @returns {*}
*/
const initState = (initialState) => {
  if (!isValid(initialState)) {
    throw Error('Invalid initial stories narrators state');
  }

  const { items, size, activeItem, filters } = initialState;
  return {
    items,
    size,
    activeItem,
    filters,
  };
};

/**
* @description Getters
* @type {*}
*/
export const getters = {
  items: ({ items }) => items,
  size: ({ size }) => size,
  activeItem: ({ activeItem }) => activeItem,
  filters: ({ filters }) => filters,
};

const actions = {
  setFilters: ({ commit }, nextFilters) => {
    commit('FILTER', nextFilters);
  },
  reset: ({ commit }) => (
    commit('SET', initialState.storiesNarrators)
  ),
  set: ({ commit }, narrators) => {
    commit('SET', narrators);
  },
};

const mutations = {
  SET(state, narrators) {
    state.items = narrators.items;
    state.size = narrators.size;
    state.activeItem = narrators.activeItem;
    state.filters = narrators.filters;
  },
  FILTER(state, filters) {
    state.filters = filters;
  },
};

export default initialState => ({
  namespaced: true,
  state: initState(initialState),
  getters,
  actions,
  mutations,
});
